import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ConnectedProps } from "react-redux";
import { Image, Row, Skeleton, Typography } from "antd";

import connector from "./Container";
import DashboardCardWithImage from "../../../shared/DashboardCardWithImage";
import { ReactComponent as CourseIcon } from "../../../../assets/images/reusable-items/course.svg";
const { Text } = Typography;

const HomeCourse = (props: ConnectedProps<typeof connector>) => {
  const {
    courses,
    loading,
    loaded,
    actions: { getCourse },
  } = props;

  useEffect(() => {
    if (loaded) return;
    getCourse();
  }, []);

  if (loading) {
    return (
      <div className="h-[292px]">
        <Skeleton active paragraph={{ rows: 7 }} />
      </div>
    );
  }

  return (
    <>
      <Row justify={"space-between"} align={"middle"}>
        <div className="text-neutral-600 font-semibold text-base">Courses</div>
        {courses && courses.length > 0 && (
          <Link
            to={"/user/course"}
            className="text-primary-600 font-semibold text-[12px]"
          >
            See All
          </Link>
        )}
      </Row>
      <div className="mt-4 flex gap-4">
        {courses && courses.length > 0 ? (
          <>
            <DashboardCardWithImage content={courses[0]} />
            <DashboardCardWithImage content={courses[1]} />
          </>
        ) : (
          <div className="flex mt-10 justify-center w-full h-[212px]">
            <div className={`px-[40px]`}>
              <div className="flex flex-col gap-10 items-center justify-center">
                <div className="h-[60px]">
                  <CourseIcon className="h-full w-full fill-primary-400" />
                </div>
                <Text className="text-neutral-600 text-xl font-bold text-center">
                  There are currently no
                  <div>Courses</div>
                </Text>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default HomeCourse;
